export const groupingsExcludingForecastedCostsColumns = new Set([
  "resource",
  "cost_allocation_tag",
  "cost_allocation_tag_value",
]);
